import { createContext, useContext } from 'react'
import { type BroadcastDetailOneTimeStore } from 'pages/broadcasts/ui/BroadcastDetail/BroadcastDetailOneTime'

export const BroadcastDetailOneTimeContext = createContext<BroadcastDetailOneTimeStore | null>(null)

export function useBroadcastDetailOneTimeContext() {
  const context = useContext(BroadcastDetailOneTimeContext)
  if (context === null) {
    throw new Error(
      'You have forgotten to wrap your root component with BroadcastDetailOneTimeContext'
    )
  }
  return context
}
